module.exports = __webpack_public_path__ + "img/user-group.b9ed60a6.svg";